'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_HiddenEvent$() {
}
export { $c_Ldev_cheleb_scalamigen_HiddenEvent$ as $c_Ldev_cheleb_scalamigen_HiddenEvent$ };
$p = $c_Ldev_cheleb_scalamigen_HiddenEvent$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_HiddenEvent$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_HiddenEvent$() {
}
export { $h_Ldev_cheleb_scalamigen_HiddenEvent$ as $h_Ldev_cheleb_scalamigen_HiddenEvent$ };
$h_Ldev_cheleb_scalamigen_HiddenEvent$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 800098032;
});
$p.b = (function() {
  return "HiddenEvent";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "HiddenEvent";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.y = (function(p) {
  return this;
});
var $d_Ldev_cheleb_scalamigen_HiddenEvent$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_HiddenEvent$, "dev.cheleb.scalamigen.HiddenEvent$", ({
  jb: 1,
  bN: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ldev_cheleb_scalamigen_HiddenEvent$ as $d_Ldev_cheleb_scalamigen_HiddenEvent$ };
var $n_Ldev_cheleb_scalamigen_HiddenEvent$;
function $m_Ldev_cheleb_scalamigen_HiddenEvent$() {
  if ((!$n_Ldev_cheleb_scalamigen_HiddenEvent$)) {
    $n_Ldev_cheleb_scalamigen_HiddenEvent$ = new $c_Ldev_cheleb_scalamigen_HiddenEvent$();
  }
  return $n_Ldev_cheleb_scalamigen_HiddenEvent$;
}
export { $m_Ldev_cheleb_scalamigen_HiddenEvent$ as $m_Ldev_cheleb_scalamigen_HiddenEvent$ };
